/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContainerDTO } from './ContainerDTO';
import {
    ContainerDTOFromJSON,
    ContainerDTOFromJSONTyped,
    ContainerDTOToJSON,
} from './ContainerDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface ContainerPageDTO
 */
export interface ContainerPageDTO {
    /**
     * 
     * @type {Array<ContainerDTO>}
     * @memberof ContainerPageDTO
     */
    content?: Array<ContainerDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof ContainerPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContainerPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContainerPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ContainerPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof ContainerPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof ContainerPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof ContainerPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof ContainerPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof ContainerPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the ContainerPageDTO interface.
 */
export function instanceOfContainerPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContainerPageDTOFromJSON(json: any): ContainerPageDTO {
    return ContainerPageDTOFromJSONTyped(json, false);
}

export function ContainerPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContainerPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(ContainerDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function ContainerPageDTOToJSON(value?: ContainerPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(ContainerDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

